/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionResultModel } from '../../models/session-result-model';

export interface SessionMemberLastScanGetSystemIdentifierIdGet$Params {
  systemIdentifierId: string;
}

export function sessionMemberLastScanGetSystemIdentifierIdGet(http: HttpClient, rootUrl: string, params: SessionMemberLastScanGetSystemIdentifierIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<SessionResultModel>> {
  const rb = new RequestBuilder(rootUrl, sessionMemberLastScanGetSystemIdentifierIdGet.PATH, 'get');
  if (params) {
    rb.path('systemIdentifierId', params.systemIdentifierId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<SessionResultModel>;
    })
  );
}

sessionMemberLastScanGetSystemIdentifierIdGet.PATH = '/Session/MemberLastScanGet/{systemIdentifierId}';
